import { SITE_URL } from "@/components/PublicSeo";

const organization = {
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: "LicitX",
    url: `${SITE_URL}/`,
    logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/licitx-logo-512.png`,
        width: 512,
        height: 139,
    },
    email: "hola@licitx.cl",
    description: "Plataforma chilena para detectar, priorizar, analizar y gestionar oportunidades de compras públicas.",
    areaServed: { "@type": "Country", name: "Chile" },
};

const website = {
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: "LicitX",
    url: `${SITE_URL}/`,
    inLanguage: "es-CL",
    publisher: { "@id": `${SITE_URL}/#organization` },
};

const software = {
    "@type": "SoftwareApplication",
    "@id": `${SITE_URL}/#software`,
    name: "LicitX",
    url: `${SITE_URL}/`,
    operatingSystem: "Web",
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Government Procurement Software",
    inLanguage: "es-CL",
    countriesSupported: "CL",
    description: "Software para empresas proveedoras del Estado que centraliza licitaciones, Compras Ágiles y Órdenes de Compra, aplica reglas de prioridad, analiza competencia y apoya la preparación de propuestas.",
    featureList: [
        "Sincronización periódica con ChileCompra",
        "Reglas de prioridad explicables por palabras clave, monto, organismo y región",
        "Alertas de licitaciones y Compras Ágiles",
        "Análisis histórico de competidores, precios y organismos",
        "Oportunidades anticipadas y alertas escalonadas",
        "Generación de propuestas comerciales con inteligencia artificial",
        "Gestión documental y post-adjudicación",
        "Reportes y exportaciones para equipos comerciales",
    ],
    publisher: { "@id": `${SITE_URL}/#organization` },
};

export const buildHomeSchemas = (faqItems) => [{
    "@context": "https://schema.org",
    "@graph": [
        organization,
        website,
        software,
        {
            "@type": "WebPage",
            "@id": `${SITE_URL}/#webpage`,
            url: `${SITE_URL}/`,
            name: "Software de licitaciones públicas y ChileCompra | LicitX",
            description: "Detecta oportunidades, anticipa relicitaciones, analiza competencia y prepara propuestas para vender al Estado con información de ChileCompra.",
            inLanguage: "es-CL",
            isPartOf: { "@id": `${SITE_URL}/#website` },
            about: { "@id": `${SITE_URL}/#software` },
        },
        {
            "@type": "FAQPage",
            "@id": `${SITE_URL}/#faq`,
            mainEntity: faqItems.map(({ q, a }) => ({
                "@type": "Question",
                name: q,
                acceptedAnswer: { "@type": "Answer", text: a },
            })),
        },
    ],
}];

export const buildBlogListSchemas = () => [{
    "@context": "https://schema.org",
    "@graph": [
        organization,
        {
            "@type": "Blog",
            "@id": `${SITE_URL}/blog#blog`,
            url: `${SITE_URL}/blog`,
            name: "Blog LicitX",
            description: "Guías y análisis sobre licitaciones públicas, ChileCompra, Compra Ágil, competencia y venta al Estado.",
            inLanguage: "es-CL",
            publisher: { "@id": `${SITE_URL}/#organization` },
        },
        {
            "@type": "CollectionPage",
            url: `${SITE_URL}/blog`,
            name: "Blog sobre licitaciones y Mercado Público | LicitX",
            isPartOf: { "@id": `${SITE_URL}/#website` },
            about: { "@id": `${SITE_URL}/blog#blog` },
        },
    ],
}];

export const buildVideoSchemas = (videos) => [{
    "@context": "https://schema.org",
    "@graph": [
        organization,
        {
            "@type": "CollectionPage",
            url: `${SITE_URL}/videos`,
            name: "Tutoriales de ChileCompra y licitaciones | LicitX",
            description: "Videoteca en español sobre LicitX, reglas de prioridad, Compras Ágiles y Órdenes de Compra.",
            inLanguage: "es-CL",
            isPartOf: { "@id": `${SITE_URL}/#website` },
            hasPart: videos.map((video) => ({
                "@type": "VideoObject",
                name: video.title,
                description: video.description,
                thumbnailUrl: `${SITE_URL}${video.poster}`,
                contentUrl: `${SITE_URL}${video.src}`,
                duration: video.isoDuration,
                uploadDate: video.uploadDate,
                inLanguage: "es-CL",
            })),
        },
    ],
}];

export const buildMcpSchemas = () => [{
    "@context": "https://schema.org",
    "@graph": [
        organization,
        {
            "@type": "TechArticle",
            url: `${SITE_URL}/mcp`,
            headline: "MCP para analizar licitaciones con Claude, Cursor y ChatGPT",
            description: "Guía para conectar el MCP empresarial de solo lectura de LicitX y consultar información autorizada de licitaciones y mercado público.",
            inLanguage: "es-CL",
            author: { "@id": `${SITE_URL}/#organization` },
            publisher: { "@id": `${SITE_URL}/#organization` },
            isPartOf: { "@id": `${SITE_URL}/#website` },
        },
    ],
}];

export const buildContactSchemas = () => [{
    "@context": "https://schema.org",
    "@graph": [
        organization,
        {
            "@type": "ContactPage",
            url: `${SITE_URL}/contacto`,
            name: "Solicitar demo de LicitX",
            description: "Conversa con el equipo de LicitX sobre alertas, análisis de mercado, propuestas con IA y gestión de licitaciones públicas.",
            inLanguage: "es-CL",
            isPartOf: { "@id": `${SITE_URL}/#website` },
        },
    ],
}];
